import React from "react";

/**
 * Isolates LoanRecyclingCard from the rest of the Account Aggregator view.
 * If anything inside it throws during render, this boundary catches it and
 * renders nothing (or a small inline note) instead of crashing the parent
 * component tree — the BSI panel, EOD balance, and everything else on this
 * tab keep working regardless of what happens inside this card.
 */
export default class LoanRecyclingErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("LoanRecyclingCard crashed and was isolated:", error, info);
  }

  componentDidUpdate(prevProps) {
    // Reset once the underlying application changes, so a new mount gets a fresh chance.
    if (this.state.hasError && (prevProps.userId !== this.props.userId || prevProps.appId !== this.props.appId)) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
